import { faCaretRight } from "@fortawesome/free-solid-svg-icons/faCaretRight";
import { faCircleLeft } from "@fortawesome/free-solid-svg-icons/faCircleLeft";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons/faCircleXmark";
import { faClose } from "@fortawesome/free-solid-svg-icons/faClose";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons/faPenToSquare";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React from "react"
const estilosBreadcrumb2 = require('./breadcrumb2.module.scss').default
const estilosBotoes = require('../../estilos/botoes.module.scss').default
import clsx from 'clsx'

export type Breadcrumb2Props = {
    passos: string[]
    exibirBotaoLimpar?:boolean
    exibirBotaoVoltar?: boolean
    exibirBotaoEditar?: boolean
    processando?: boolean
    id?: string
    onBotaoLimparClicado?: () => void
    onBotaoVoltarClicado?: ()=> void
    onBotaoEditarClicado?: ()=> void
    onPassoSelecionado?: (passo:string) => void
}

export const Breadcrumb2 = (props: Breadcrumb2Props) => {

    const renderizarPasso = (texto: string, indice: number) => {
        const key = props.id ? `${props.id}_passo_${indice}` : `passo_${indice}`; // Chave única
        const ultimoIndice = () => indice == props.passos.length - 1
        const classeH2 = clsx(ultimoIndice() 
                            ? estilosBreadcrumb2.passoAtivo 
                            : props.processando 
                                ? estilosBreadcrumb2.passoDesativado 
                                : estilosBreadcrumb2.passoNaoAtivo, 'no-global-h2')
        const onClick = ultimoIndice() || props.processando ? () => {} : () => props.onPassoSelecionado?.(texto)
        
        return  indice == 0 
                    ? <h2 
                        className={classeH2} 
                        onClick={onClick}
                        id={props.id ? `${props.id}_Breadcrumb_H2_${indice}` : `_Breadcrumb_Icon_${indice}`}
                        key={key} // Key no nível superior
                      >{texto}</h2> 
                    : <React.Fragment key={key}> {/* Key no Fragment */}
                        <div className={classeH2}
                            id={props.id ? `${props.id}_Breadcrumb_div_${indice}` : `_Breadcrumb_Icon_${indice}`}
                        >
                            <FontAwesomeIcon icon={faCaretRight} 
                                id={props.id ? `${props.id}_Breadcrumb_Icon_${indice}` : `_Breadcrumb_Icon_${indice}`}
                            />
                        </div> 
                        <h2 className={classeH2} onClick={onClick}
                            style={{ cursor: indice == props.passos.length - 1 ? 'not-allowed': '' }}
                            id={props.id ? `${props.id}_Breadcrumb_H2_final_${indice}` : `_Breadcrumb_H2_final_${indice}`}
                        >{texto}</h2>
                      </React.Fragment>
    }

    const botaoLimpar = <>
        <button className={clsx(estilosBotoes.botaoIcone, estilosBotoes.botaoIconeVermelho, 'no-global-button')}
            disabled={props.processando}
            id={props.id?.length > 0 ? `${props.id}_Breadcrumb_BtnLimpar` : undefined}
            key={props.id?.length > 0 ? `${props.id}_Breadcrumb_BtnLimpar` : undefined}
            onClick={() => props.onBotaoLimparClicado?.()}>

            <FontAwesomeIcon
                icon={faCircleXmark}/>

            Limpar
        </button>
    </>

    const botaoVoltar = <>
        <button className={clsx(estilosBotoes.botaoIcone, estilosBotoes.botaoIconeVermelho, 'no-global-button')}
            disabled={props.processando}
            id={props.id?.length > 0 ? `${props.id}_Breadcrumb_BtnVoltar` : undefined}
            key={props.id?.length > 0 ? `${props.id}_Breadcrumb_BtnVoltar` : undefined}
            onClick={() => props.onBotaoVoltarClicado?.()}>

            <FontAwesomeIcon
                icon={faCircleLeft}/>

            Voltar
        </button>
    </>

    const botaoEditar = <>
        <button className={clsx(estilosBotoes.botaoIcone, estilosBotoes.botaoIconeAzul, 'no-global-button')}
            id={props.id?.length > 0 ? `${props.id}_Breadcrumb_BtnEditar` : undefined}
            key={props.id?.length > 0 ? `${props.id}_Breadcrumb_BtnEditar` : undefined}
            onClick={() => props.onBotaoEditarClicado?.()}>

            <FontAwesomeIcon
                id={props.id?.length > 0 ? `${props.id}_Breadcrumb_IconeBtnEditar` : undefined}
                key={props.id?.length > 0 ? `${props.id}_Breadcrumb_IconeBtnEditar` : undefined}
                icon={faPenToSquare}/>

            Editar
        </button>
    </>
    
    return <>
        <div className={clsx("_flex _flex-row _gap-4", estilosBreadcrumb2.container)}
            id={props.id ? `${props.id}_Breadcrumb_Passos` : undefined}
        >
            {props.passos.map((passo, indice) => renderizarPasso(passo, indice))}
        </div>
        
        <div className="_flex _flex-row _gap-4"
            id={props.id ? `${props.id}_Breadcrumb_Botoes` : undefined}
        >
            {props.exibirBotaoLimpar && botaoLimpar}
            {props.exibirBotaoVoltar && botaoVoltar}
            {props.exibirBotaoEditar && botaoEditar}
        </div>
    </>
}